import { Buyer } from '@40seas/entities/buyers';
import { Omit } from '@40seas/entities/common';
import { PaymentMethod } from '@40seas/entities/payment-methods';
import { BaseEntityFieldsArray, Currency } from '@40seas/models';
import { Funds } from './funds.entity';
import { FundsStatus } from './funds.status.enum';

export class CreateFundsDto extends Omit(
    Funds,
    [...BaseEntityFieldsArray, 'status', 'paymentMethod', 'buyer'],
    ['status', 'paymentMethod', 'buyer'],
) {
    status?: FundsStatus;
    paymentMethod?: string | PaymentMethod;
    buyer?: string | Buyer;
}
